import React from "react";
import { FormattedMessage } from "react-intl";

import { MTXC_SITE, MTXC_FAQ_SITE } from "components/dashboard/constants";

const MTXMenu = [
  {
    url: `${MTXC_SITE}/%LANG%/pricing.html`,
    name: "Menu.Pricing",
  },
  {
    url: `${MTXC_SITE}/%LANG%/coverage.html`,
    name: "Menu.Coverage",
  },
  {
    url: `${MTXC_FAQ_SITE}/%LANG%`,
    name: "Menu.Faq",
  },
  {
    url: `${MTXC_SITE}/%LANG%/contact-us.html`,
    name: "Menu.ContactUs",
  },
];

const AppLangToFaqSiteLang = {
  jp: "en-us",
  cn: "zh",
  en: "en-us",
  ru: "ru",
};

const Menu = ({ locale, className, region, resources = {} }) => {
  const menuLink = (url) => {
    if (url.includes(MTXC_FAQ_SITE)) {
      return url.replace("%LANG%", AppLangToFaqSiteLang[locale] || "en-us");
    }
    if (
      locale === "ru" &&
      (url.includes("pricing") || url.includes("coverage") || url.includes("contact-us"))
    ) {
      return url.replace("%LANG%", "en");
    }
    return url.replace("%LANG%", locale === "jp" ? "en" : locale);
  };

  const menu =
    resources &&
    Array.isArray(resources.top_menu) &&
    resources.top_menu.length > 0
      ? resources.top_menu
      : MTXMenu;

  return (
    <ul className={className}>
      {menu.map((el, i) => (
        <li key={i}>
          <a href={menuLink(el.url)} target="_blank">
            <FormattedMessage id={el.name} defaultMessage={el.name} />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default Menu;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/menu.js